// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lithium_battery_desc[data-v-5770c196] { margin-bottom:14px; color:#222; font-size:14px; line-height:1.45;\n}\n.lithium_battery_box[data-v-5770c196] { border:1px solid #d4d7df;\n}\n.lithium_battery_options li + li[data-v-5770c196] { margin-top:9px;\n}\n.lithium_battery_options label[data-v-5770c196] { color:#222;\n}\n", ""]);
// Exports
module.exports = exports;
